import { render, staticRenderFns } from "./MainCategoryLayout.vue?vue&type=template&id=70ccf710"
import script from "./MainCategoryLayout.vue?vue&type=script&lang=js"
export * from "./MainCategoryLayout.vue?vue&type=script&lang=js"
import style0 from "./MainCategoryLayout.vue?vue&type=style&index=0&id=70ccf710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports